import axios from 'axios'

export default {
    namespaced: true,
    state: {
        bursaryApplicationAttachments: [],
        bursaryApplicationAttachment: {},
    },
    mutations: {
        SET_BURSARY_APPLICATION_ATTACHMENTS(state, payload) {
            state.bursaryApplicationAttachments = payload;
        },
        SET_BURSARY_APPLICATION_ATTACHMENT(state, payload) {
            state.bursaryApplicationAttachment = payload;
        },
    },
    actions: {
        async FetchBursaryApplicationAttachments({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/bursary/attachments/list`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_BURSARY_APPLICATION_ATTACHMENTS', response.data.payload);
                            resolve(response.data.message);
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchBursaryApplicationAttachments: ${error.message}`));
            });
        },
        async FetchBursaryApplicationAttachment({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/bursary/attachments/fetch`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_BURSARY_APPLICATION_ATTACHMENT', response.data.payload);
                            resolve(response.data.message);
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchBursaryApplicationAttachment: ${error.message}`));
            });
        },
        async InsertBursaryApplicationAttachment({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/bursary/attachments/insert`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`InsertBursaryApplicationAttachment: ${error.message}`));
            });
        },
        async DeleteBursaryApplicationAttachment({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/bursary/attachments/delete`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`DeleteBursaryApplicationAttachment: ${error.message}`));
            });
        },
    },
    getters: {
        BursaryApplicationAttachments(state) { return state.bursaryApplicationAttachments; },
        BursaryApplicationAttachment(state) { return state.bursaryApplicationAttachment; },
    }
}
